"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Emoji_1 = require("./Emoji");
exports.default = Emoji_1.default;
//# sourceMappingURL=index.js.map